import FrequencyTrendLimitConfigurationService from "../../service/FrequencyTrendLimitConfigurationService";
import LimitConfiguratorActions from "./LimitConfiguratorActions";
import LimitConfiguratorGetters from "./LimitConfiguratorGetters";
import LimitConfiguratorMutations from "./LimitConfiguratorMutations";

const state = FrequencyTrendLimitConfigurationService.EmptyLimitConfiguratorState();

const { actions } = LimitConfiguratorActions;

const { mutations } = LimitConfiguratorMutations;

const { getters } = LimitConfiguratorGetters;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced,
};